export const ERROR_GENERIC = 'There was an error.';